<template>
  <h1 class="font-mono font-bold mt-24 text-indigo-500">{ <span class="text-white">My Contact</span> }</h1>
  <div class="relative mt-12 mb-16  xl:w-1/2 sm:w-2/3 w-4/5 m-auto">
    <div id="BGCard" class="flex flex-col items-center rounded-lg border shadow-md md:flex-row md:max-w-xl dark:border-gray-700 dark:bg-gray-900">
      <img class="object-cover w-full h-96 rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src="../assets/memojiwork.png" alt="">
      <div class="flex flex-col justify-between p-4 leading-normal">
        <form id="MailForm">
          <div class="flex flex-row gap-2">
            <div class="flex flex-col">
              <label for="to_name" class="text-sm text-gray-600 dark:text-gray-400">Name</label>
              <input class="w-full px-3 py-2 mb-2 text-sm text-gray-700 bg-gray-200 rounded border border-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 focus:outline-none focus:border-gray-500 focus:bg-gray-900" type="text" value="" name="nom" id="nom" placeholder="Nom">
              <input type="hidden" name="to_name" id="to_name"/>
            </div>
            <div class="flex flex-col">
              <label for="from_name" class="text-sm text-gray-600 dark:text-gray-400">Email</label>
              <input class="w-full px-3 py-2 mb-2 text-sm text-gray-700 bg-gray-200 rounded border border-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 focus:outline-none focus:border-gray-500 focus:bg-gray-900 active:bg-gray-900" value="" type="email" name="from_name" id="from_name" placeholder="Email">
            </div>
          </div>
          <div class="flex flex-col">
            <label for="message" class="text-sm text-gray-600 dark:text-gray-400">Message</label>
            <textarea class="w-full px-3 py-2 mb-2 text-sm text-gray-700 bg-gray-200 rounded border border-gray-400 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 focus:outline-none focus:border-gray-500 focus:bg-gray-900" value="" name="message" id="message" placeholder="Message"></textarea>
          </div>
          <div class="flex flex-col">
            <button id="sendMail" class="w-full px-3 py-2 mb-2 text-sm text-white bg-indigo-500 rounded border border-indigo-500 dark:border-gray-600 dark:bg">Send</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Contact"
}
</script>

<style scoped>

</style>